"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const FormContexts_1 = require("./Contexts/FormContexts");
// Todo: Remove this. Not used at all. See Karl for details.
const FormComponent = props => {
    const { component, controlPath } = props;
    const FormControl = (0, FormContexts_1.useFormControl)(component);
    return FormControl ? react_1.default.createElement(FormControl, { controlDefinition: component, controlPath: controlPath || '' }) : null;
};
exports.default = FormComponent;
